import { render, staticRenderFns } from "./Speisen.vue?vue&type=template&id=3d96fb9e&scoped=true"
import script from "./Speisen.vue?vue&type=script&lang=js"
export * from "./Speisen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96fb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d96fb9e')) {
      api.createRecord('3d96fb9e', component.options)
    } else {
      api.reload('3d96fb9e', component.options)
    }
    module.hot.accept("./Speisen.vue?vue&type=template&id=3d96fb9e&scoped=true", function () {
      api.rerender('3d96fb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Speisen.vue"
export default component.exports